import { motion } from "framer-motion";
import type { ReactNode } from "react";

import { PAGE_TRANS_VARIANTS } from "@/common/constants/AnimationVariants";

type Props = {
  children: ReactNode;
  animationType?: keyof typeof PAGE_TRANS_VARIANTS;
};

const transition = { duration: 0.4, ease: "easeInOut" } as const;

export default function PageWrapper({
  children,
  animationType = "fadeSlideHorizontal",
}: Props) {
  const selected = PAGE_TRANS_VARIANTS[animationType];

  return (
    <motion.div
      className="h-full bg-background text-foreground"
      initial="initial"
      animate="animate"
      exit="exit"
      variants={selected.variants}
      transition={transition}
    >
      {children}
    </motion.div>
  );
}
